'use strict';

(function () {
  "use strict";

  function LoadSlider(element, className, bulletId) {
    this.element = element;
    this.className = className;
    this.bulletId = bulletId;

    this.navTimeout;
    this.currentNavLocation = 0;
    this.secondNavLocation = 0;

    this.ourElement = this.element.querySelectorAll("." + this.className);
    if (this.ourElement && this.ourElement[0]) {
      this.ourElement[0].style.display = 'block';
    }

    var htm = '';
    var that = this;
    this.bulletElement = this.element.querySelector("." + bulletId);
    this.ourElement.forEach(function (elem, index) {
      var anchor = document.createElement('a');
      anchor.className = "ms-bullet";
      anchor.addEventListener("click", function () {
        that.navigate(index);
      })
      that.bulletElement.appendChild(anchor);
    });
    this.bulletNavs = this.bulletElement.querySelectorAll('a');
    if (this.bulletNavs && this.bulletNavs[0]) {
      this.bulletNavs[0].className = 'ms-bullet active';
    }
    this.autonavigate();
    this.element.querySelector(".cta.prev").addEventListener("click", function () {
      that.navigateByClick("prev");
    })
    this.element.querySelector(".cta.next").addEventListener("click", function () {
      that.navigateByClick("next");
    })
  }

  LoadSlider.prototype.autonavigate = function () {
    const self = this;
    if (self.currentNavLocation + 1 < self.bulletNavs.length) {
      self.secondNavLocation = self.currentNavLocation + 1;
    } else {
      self.secondNavLocation = 0;
    }
    var that = self;
    self.navTimeout = setTimeout(function () {
      that.navigate(self.secondNavLocation);
    }, 12000);
  };

  LoadSlider.prototype.navigateByClick = function (type) {
    const self = this;
    clearInterval(self.navTimeout);
    if (type == "next") {
      if (self.currentNavLocation + 1 < self.bulletNavs.length) {
        self.secondNavLocation = self.currentNavLocation + 1;
      } else {
        self.secondNavLocation = 0;
      }
      self.navigate(self.secondNavLocation);
    } else {
      if ((self.currentNavLocation - 1) < 0) {
        this.navigate(self.bulletNavs.length - 1);
      } else {
        this.navigate(self.currentNavLocation - 1);
      }
    }
  }

  LoadSlider.prototype.navigate = function (e) {
    if (e == undefined) {
      e == this.secondNavLocation;
    }
    for (var i = 0; i < this.bulletNavs.length; i++) {
      if (i == e) {
        this.sliderNext(i);
        this.currentNavLocation = i;
        clearInterval(this.navTimeout);
        this.autonavigate();
      } else {
        this.sliderPrev(i);
      }
    }
  };

  LoadSlider.prototype.sliderNext = function (i) {
    if (this.bulletNavs && this.bulletNavs[i]) {
      this.bulletNavs[i].className = 'ms-bullet active';
    }
    if (this.ourElement && this.ourElement[i]) {
      this.ourElement[i].style.display = 'block';
      var elem = this.ourElement[i];
      var that = this;
      setTimeout(function () {
        elem.className = that.className + ' active'
      }, 400);
    }
  },

    LoadSlider.prototype.sliderPrev = function (i) {
      if (this.bulletNavs && this.bulletNavs[i]) {
        this.bulletNavs[i].className = 'ms-bullet';
      }
      if (this.ourElement && this.ourElement[i]) {
        var elem = this.ourElement[i];
        setTimeout(function () {
          elem.style.display = 'none'
        }, 1000);
        this.ourElement[i].className = this.className;
      }
    };

  window.slider = LoadSlider;
})();